import { r as registerInstance, h } from './index-16dc7dde.js';

const productAtozRangesCss = "";

let ProductAtozRanges = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.rangeData = [];
  }
  render() {
    var _a;
    if (((_a = this.rangeData) === null || _a === void 0 ? void 0 : _a.length) === 0)
      return null;
    return (h("ul", { class: 'product-finder-result' }, this.rangeData.map((rangeCategoryData) => {
      return (h("li", null, h("span", { class: 'product-finder-result__heading' }, rangeCategoryData === null || rangeCategoryData === void 0 ? void 0 : rangeCategoryData.rangeGroupId), h("ul", null, rangeCategoryData.rangeData.map((range) => {
        return (h("li", { class: 'product-finder-result__item--commercial-status' }, h("span", { class: "commercial-status-color", style: { 'background-color': range === null || range === void 0 ? void 0 : range.color } }), (range === null || range === void 0 ? void 0 : range.displayName) && !(range === null || range === void 0 ? void 0 : range.formattedDisplayName) && (h("a", { class: 'product-finder-result__link', href: range === null || range === void 0 ? void 0 : range.rangeUrl }, range === null || range === void 0 ? void 0 : range.displayName)), (range === null || range === void 0 ? void 0 : range.formattedDisplayName) && (h("a", { class: 'product-finder-result__link', href: range === null || range === void 0 ? void 0 : range.rangeUrl, innerHTML: range === null || range === void 0 ? void 0 : range.formattedDisplayName }))));
      }))));
    })));
  }
};
ProductAtozRanges.style = productAtozRangesCss;

export { ProductAtozRanges as product_atoz_ranges };
